const cityPoints = [
  {
    icon: "ri-money-cny-circle-line",
    label: "手数料",
    text: "400円〜2,400円（品目・サイズにより異なる）",
  },
  {
    icon: "ri-file-list-3-line",
    label: "事前準備",
    text: "電話またはインターネットで申込み。コンビニ等で「粗大ごみ処理手数料券」を購入",
  },
  {
    icon: "ri-hand-coin-line",
    label: "搬出",
    text: "ご自身で収集場所へ当日朝8時までに出す必要があります",
  },
  {
    icon: "ri-time-line",
    label: "待ち時間",
    text: "申込みから約1週間程度のお待ちが必要です",
  },
  {
    icon: "ri-calendar-event-line",
    label: "回収時間",
    text: "8:30〜16:00の間で収集（時間の指定はお約束できません）",
  },
  {
    icon: "ri-close-circle-line",
    label: "対象外",
    text: "エアコン・テレビ・冷蔵庫・洗濯機は家電リサイクル法対象で回収不可",
  },
  {
    icon: "ri-error-warning-line",
    label: "その他制限",
    text: "ガラクタ類はインターネット受付不可。品目ごとに手数料を計算する必要があります",
  },
];

const companyPoints = [
  {
    icon: "ri-price-tag-3-line",
    label: "料金",
    text: "9,000円〜50,000円（軽トラ〜4トン、税込・見積無料）",
  },
  {
    icon: "ri-smartphone-line",
    label: "事前準備",
    text: "電話またはLINEで写真見積り。作業日をお客様のご都合に合わせて調整",
  },
  {
    icon: "ri-hand-heart-line",
    label: "搬出",
    text: "スタッフが室内から搬出・積み込みまですべて対応。お客様の手を煩わせません",
  },
  {
    icon: "ri-timer-flash-line",
    label: "待ち時間",
    text: "最短即日対応可能。急なご依頼にもスピーディーに対応します",
  },
  {
    icon: "ri-calendar-check-line",
    label: "回収時間",
    text: "お客様のご希望に合わせて時間帯を調整できます",
  },
  {
    icon: "ri-check-double-line",
    label: "対応品目",
    text: "家具・家電・大型ゴミを幅広く回収。家電リサイクル法対象品も適正に対応",
  },
  {
    icon: "ri-stack-line",
    label: "まとめて対応",
    text: "お部屋丸ごと・大量の不用品も一括で回収。品目ごとの手数料計算は不要",
  },
];

export default function Comparison() {
  return (
    <section id="comparison" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            COMPARISON
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            京都市の粗大ゴミ受付と
            <span className="text-primary-500">比較してみませんか</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            京都市でも粗大ゴミの戸別収集を受け付けています。
            ご自身で申込み・搬出できる場合は便利ですが、忙しい方や大量の場合、民間の回収サービスが便利な場合もあります。
            両方の特徴を比較して、ご自身に合った方法をお選びください。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {/* City Card */}
          <div className="bg-background-50 border border-secondary-200 rounded-lg p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100">
                <i className="ri-government-line text-secondary-700 text-lg"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-foreground-900">
                京都市の粗大ゴミ受付
              </h3>
            </div>
            <div className="space-y-4">
              {cityPoints.map((p) => (
                <div key={p.label} className="flex gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0 rounded-full bg-secondary-100">
                    <i className={`${p.icon} text-secondary-700 text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-xs font-bold text-secondary-800 mb-0.5">
                      {p.label}
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {p.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-5 text-xs text-foreground-500 leading-relaxed">
              ※京都市公式サイト（
              <a
                href="https://www.city.kyoto.lg.jp/kankyo/page/0000001317.html"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-foreground-700 cursor-pointer"
              >
                city.kyoto.lg.jp
              </a>
              ）の情報に基づく。最新の手数料や受付方法については京都市へ直接お問い合わせください。
            </p>
          </div>

          {/* Company Card */}
          <div className="bg-primary-500 border border-primary-500 rounded-lg p-6 md:p-8 text-background-50">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-background-50/15">
                <i className="ri-truck-line text-background-50 text-lg"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-background-50">
                京都ゴミ処分センター
              </h3>
            </div>
            <div className="space-y-4">
              {companyPoints.map((p) => (
                <div key={p.label} className="flex gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0 rounded-full bg-background-50/15">
                    <i className={`${p.icon} text-background-50 text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-xs font-bold text-background-50/90 mb-0.5">
                      {p.label}
                    </p>
                    <p className="text-sm text-background-50/85 leading-relaxed">
                      {p.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-5 text-xs text-background-50/70 leading-relaxed">
              ※家電リサイクル法対象品（エアコン・テレビ・冷蔵庫・洗濯機）はリサイクル料金が別途必要です。詳しくはお見積り時にご案内いたします。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 text-center">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
            少量・1品だけの場合は京都市の受付もお得ですが、
            家具・家電が複数点ある場合や、搬出が大変な場合は
            <strong className="text-foreground-900">おまかせ回収</strong>が便利です。
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="tel:0120024747"
              className="inline-flex items-center justify-center gap-2.5 px-6 py-4 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors"
            >
              <i className="ri-phone-fill text-lg md:text-xl"></i>
              電話で無料相談
            </a>
            <a
              href="https://lin.ee/xf3zQex"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2.5 px-6 py-4 rounded-md bg-accent-700 hover:bg-accent-800 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors"
            >
              <i className="ri-line-fill text-lg md:text-xl"></i>
              LINEで写真見積り
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}